import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ContactButtons from "./components/ContactButtons";
import "./App.css";

const Home = lazy(() => import("./pages/Home"));
const ServerEmail = lazy(() => import("./pages/ServerEmail"));
const MongoDB = lazy(() => import("./pages/MongoDB"));
const SMTP = lazy(() => import("./pages/SMTP"));
const Contact = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Suspense
          fallback={
            <div className="page-shell flex flex-1 items-center justify-center px-6 py-20 text-center" style={{ color: "var(--color-text-muted)" }}>
              Loading experience...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/server-email" element={<ServerEmail />} />
            <Route path="/mongodb-setup" element={<MongoDB />} />
            <Route path="/smtp-setup" element={<SMTP />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <Footer />
        <ContactButtons />
      </div>
    </Router>
  );
}

export default App;
